import React, { Suspense } from 'react';
import { View, Text, ActivityIndicator } from 'react-native';
import styles from 'root/globals/Defaults.less';
import _ from 'root/libs/exaforte/react/lodash';
import {
    __CONTENT_TYPE_DEFAULT__,
    __CONTENT_TYPE_PASSWORD__,
    __CONTENT_TYPE_EMAIL__,
    __CONTENT_TYPE_DATE__,
    __CONTENT_TYPE_MONEY__,
    __CONTENT_TYPE_INTEGER__,
    __CONTENT_TYPE_URL__,
    __CONTENT_TYPE_TEXTAREA__,
    __CONTENT_TYPE_PHP__,
    __CONTENT_TYPE_EDITOR__,
    __CONTENT_TYPE_BOOLEAN__,
    __CONTENT_TYPE_FILE__,
    __CONTENT_TYPE_IMAGE__,
    __CONTENT_TYPE_SELECT__,
    __CONTENT_TYPE_CSS__,
    __CONTENT_TYPE_JAVASCRIPT__,
    __CONTENT_TYPE_SQL__,
    __CONTENT_TYPE_DATETIME__,
    __CONTENT_TYPE_PHONENUMBER__,
    __CONTENT_TYPE_FAXNUMBER__,
    __CONTENT_TYPE_ZIPCODE__,
    __CONTENT_TYPE_MOBILENUMBER__,
    __CONTENT_TYPE_COLOR__,
    __CONTENT_TYPE_TIME__,
    __CONTENT_TYPE_HIDDEN__,
    __CONTENT_TYPE_JSON__,
    __CONTENT_TYPE_JSON_LONG__,
    __CONTENT_TYPE_TEXTAREA_LONG__,
    __CONTENT_TYPE_MOBILE_NUMBER__,
    __CONTENT_TYPE_PERCENTAGE__,
    __CONTENT_TYPE_FLOAT__,
} from 'root/libs/exaforte/react/ReactModel';

import { CustomFormGroup, CustomTextField, CustomSelect, CustomDatePicker, CustomTimePicker, CustomFileField, CustomCheckBoxGroup, CustomCheckBox, CustomRadioButtons, CustomDateTimePicker, CustomPhoneNumberField, CustomMoneyField, CustomPercentageField, CustomColorPicker } from 'root/libs/exaforte/react/Form';

const CustomAceField    = React.lazy(() => import(/* webpackChunkName: "CustomAceField" */'root/libs/exaforte/react/form/CustomAceField'));
// Dit tijdelijk uitgecomment, omdat we het voor Gideon niet meer aan de praat kregen.
const CustomCKEditor    = React.lazy(() => import(/* webpackChunkName: "CustomCKEditor" */'root/libs/exaforte/react/form/CustomCKEditor'));
// import CustomCKEditor from 'root/libs/exaforte/react/form/CustomCKEditor';

export default class CustomForm extends React.Component {
    render()
    {
        let model                   = this.props.model;
        let fielddefines            = this.props.fielddefines || model.fielddefines;
        let group                   = this.props.group;
        let row                     = this.props.row || false;
        let action                  = this.props.action || 'edit';
        let limit                   = this.props.limit || false;
        let DisplayFieldComponent   = this.props.fieldWrapper || DisplayField;
        let FieldGroupComponent     = this.props.groupWrapper || CustomFormGroup;
        let fields                  = _.map(_.sortBy(fielddefines, fielddefine => parseInt(fielddefine.sortnumber)), (fielddefine, index) => {
            if(fielddefine.isvisible != 1 || (!_.is_empty(group) && group != fielddefine.group))
                return;

            if(limit && limit <= index)
                return;

            let disabled = (typeof fielddefine.disabled != 'undefined' && fielddefine.disabled);
            
            if(this.props.user && !_.is_allowed_action({action: action, actions: fielddefine.actions, items: this.props.user.action_items, user_policies: model.get_field_data('user_policies'), user: this.props.user.id, group: this.props.user.group_id}))
            {
                if(fielddefine.show_value_when_no_rights != 't')
                    return;
                
                disabled = true;
            }
            
            let field_props = this.props.fieldProps[fielddefine.field] || {};
            let field       = <DisplayFieldComponent key={'fielddefine-' + fielddefine.field} fielddefine={fielddefine} model={model} disabled={disabled} {...field_props} {..._.omit(this.props, ['model', 'controller', 'fielddefines', 'group', 'row', 'action', 'fieldWrapper', 'groupWrapper', 'limit'])} />;
            
            if(row)
                return field;
            
            return <FieldGroupComponent key={'fieldgroup-' + fielddefine.field}>{field}</FieldGroupComponent>;
        });
        
        if(!row)
            return fields;

        return <FieldGroupComponent row={true}>{fields}</FieldGroupComponent>;
    }
}

CustomForm.defaultProps = {
    fieldProps: {}
}

export class DisplayField extends React.Component {
    constructor(props) {
        super(props);
        
        this.getInputElement = this.getInputElement.bind(this);
    }
    
    getInputElement(extra_props) {
        let shared_props = {...this.props.model.get_field_props({field: this.props.fielddefine.field, fielddefine: this.props.fielddefine}), ...this.props, ...(extra_props || {})};
        
        switch(_.format_input(this.props.fielddefine.fieldtype_id))
        {
            case __CONTENT_TYPE_PHP__           : return <Suspense fallback={<ActivityIndicator />}><CustomAceField mode={'php'} theme={'xcode'} model={this.props.model} {...shared_props} /></Suspense>
            case __CONTENT_TYPE_EDITOR__        : return <Suspense fallback={<ActivityIndicator />}><CustomCKEditor data={shared_props.value || ''} onChange={(event, editor) => shared_props.onChangeText(editor.getData())} config={{ toolbar: [ 'heading', '|', 'basicstyles', 'bulletedList', 'numberedList', '|', 'alignCenter', '|', 'outdent', 'indent', '|', 'insertTable', '|', 'undo', 'redo' ], }} {...shared_props} {...extra_props} /></Suspense>
            // case __CONTENT_TYPE_EDITOR__        : return <CustomCKEditor data={shared_props.value || ''} onChange={(event, editor) => shared_props.onChangeText(editor.getData())} config={{ toolbar: [ 'heading', '|', 'basicstyles', 'bulletedList', 'numberedList', '|', 'alignCenter', '|', 'outdent', 'indent', '|', 'insertTable', '|', 'undo', 'redo' ], }} {...shared_props} {...extra_props} />
            case __CONTENT_TYPE_SELECT__        : 
                if(this.props.fielddefine.info && this.props.fielddefine.info.type == 'checkbox')
                {
                    if(this.props.fielddefine.info.multiple == 't')
                        return <CustomCheckBoxGroup {...shared_props}  />;
                    
                    return <CustomRadioButtons row={false} {...shared_props} />;
                }

                return <CustomSelect {...shared_props} styles={this.props.selectStyles} noOptionsMessage={()=>{return 'Geen opties beschikbaar'}} />;
            case __CONTENT_TYPE_DATE__          : return <CustomDatePicker {...shared_props} />;
            case __CONTENT_TYPE_DATETIME__      : return <CustomDateTimePicker {...shared_props} />;
            case __CONTENT_TYPE_TIME__          : return <CustomTimePicker {...shared_props} />;
            case __CONTENT_TYPE_INTEGER__       : return <CustomTextField type={'number'} {...shared_props} />;
            case __CONTENT_TYPE_FILE__          :
            case __CONTENT_TYPE_IMAGE__         : return <CustomFileField {...shared_props} model={this.props.model} {...(this.props.fielddefine.info && this.props.fielddefine.info.extensions ? {inputProps: {accept: this.props.fielddefine.info.extensions}} : {})} />;
            case __CONTENT_TYPE_PHONENUMBER__   : return <CustomPhoneNumberField {...shared_props} />;
            case __CONTENT_TYPE_MONEY__         : return <CustomMoneyField {...shared_props} />;
            case __CONTENT_TYPE_COLOR__         : return <CustomColorPicker {...shared_props} />;
            case __CONTENT_TYPE_PERCENTAGE__    : return <CustomPercentageField {...shared_props} />;
            case __CONTENT_TYPE_BOOLEAN__       :
            
                if(this.props.fielddefine.info && this.props.fielddefine.info.radio == 't')
                    return <CustomRadioButtons options={[{value: 't', label: 'Ja'}, {value: 'f', label: 'Nee'}]} {...shared_props} />;
                else
                    return <CustomCheckBox {...shared_props} mandatory={false} />;
            
            case __CONTENT_TYPE_JSON__:
            case __CONTENT_TYPE_JSON_LONG__:
            case __CONTENT_TYPE_TEXTAREA__:
            case __CONTENT_TYPE_TEXTAREA_LONG__ : return <CustomTextField multiline={true} rows={8} {...shared_props} />;
            default                             : return <CustomTextField {...shared_props} />;
        }
    }
    
    render()
    {
        let input_element = this.getInputElement();
        
        if(_.is_empty(input_element) && this.props.defaultValue)
            input_element = this.props.defaultValue;
        
        return input_element;
    }
}